import { create } from "zustand/react";
import { useShallow } from "zustand/react/shallow";

interface UsersStore {
  state: string;
  searchKeyword: string;
  actions: {
    setSearchKeyword: (keyword: string) => void;
    unMount: () => void;
    setState: (state: string) => void;
  };
}

const defaultUsersStoreData = {
  state: "active",
  searchKeyword: "",
};

const useUserStore = create<UsersStore>((set) => ({
  ...defaultUsersStoreData,
  actions: {
    setSearchKeyword: (keyword) =>
      set(() => ({
        searchKeyword: keyword,
      })),
    unMount: () =>
      set(() => ({
        ...defaultUsersStoreData,
      })),
    setState: (state) =>
      set(() => ({
        state,
      })),
  },
}));

// https://github.com/pmndrs/zustand?tab=readme-ov-file#selecting-multiple-state-slices
export const useUsersData = () =>
  useUserStore(
    useShallow((state) => ({
      state: state.state,
      searchKeyword: state.searchKeyword,
    })),
  );

export const useUsersActions = () => useUserStore((state) => state.actions);
